// Email semplice
export const validateEmail = (v = "") => /\S+@\S+\.\S+/.test(v);

// Password strength: ritorna 0..4
export const passwordStrength = (pwd = "") => {
  let s = 0;
  if (pwd.length >= 6) s++;
  if (/[A-Z]/.test(pwd) && /[a-z]/.test(pwd)) s++;
  if (/\d/.test(pwd)) s++;
  if (/[^A-Za-z0-9]/.test(pwd)) s++;
  return Math.min(4, s);
};

// CAP: 5 cifre
export const validateCAP = (v = "") => !v || /^\d{5}$/.test(v);

// Provincia: 2 lettere
export const validateProvincia = (v = "") => !v || /^[A-Za-z]{2}$/.test(v);

// Partita IVA: opzionale, se presente 11 cifre
export const validatePIVA = (v = "") => !v || /^\d{11}$/.test(v);

// Codice Fiscale: opzionale, se presente controlla sintassi e checksum
export const validateCodiceFiscale = (cf = "") => {
  if (!cf) return true;
  cf = cf.toUpperCase();
  if (!/^[A-Z0-9]{16}$/.test(cf)) return false;

  const pari = {0:0,1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,A:0,B:1,C:2,D:3,E:4,F:5,G:6,H:7,I:8,J:9,K:10,L:11,M:12,N:13,O:14,P:15,Q:16,R:17,S:18,T:19,U:20,V:21,W:22,X:23,Y:24,Z:25};
  const dispari = {0:1,1:0,2:5,3:7,4:9,5:13,6:15,7:17,8:19,9:21,A:1,B:0,C:5,D:7,E:9,F:13,G:15,H:17,I:19,J:21,K:2,L:4,M:18,N:20,O:11,P:3,Q:6,R:8,S:12,T:14,U:16,V:10,W:22,X:25,Y:24,Z:23};

  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const c = cf[i];
    const idx = i + 1; // 1-based
    sum += idx % 2 === 0 ? pari[c] : dispari[c];
  }
  const check = sum % 26;
  const expected = String.fromCharCode("A".charCodeAt(0) + check);
  return expected === cf[15];
};
